import React from 'react';
import { Link } from 'react-router-dom';
import { voucherTransactionsShape } from 'constants/propTypes';
import hash from 'object-hash';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { Cell, TableRow, Table, TableHeader } from 'components/ui/StyledTable';
import { status } from 'constants/payment';

const VoucherTransactionsTable = ({ transactions }) => (
  <Table data-cy="voucher-transactions">
    <TableHeader columns={12}>
      <Cell span={4}>
        <FormattedMessage id="transactionDetails.pnr" />
      </Cell>
      <Cell span={4}>
        <FormattedMessage id="transactionDetails.amount" />
      </Cell>
      <Cell span={4}>
        <FormattedMessage id="transactionDetails.status" />
      </Cell>
    </TableHeader>
    {transactions.map((t) => (
      <TableRow columns={12} key={hash(t)} data-cy="payment-content">
        <Cell alignItems="center" span={4} data-cy="cell">
          <Link to={`/manage/bookings/${t.pnr}/journeys`}>{t.pnr}</Link>
        </Cell>
        <Cell alignItems="center" span={4} data-cy="cell">
          <FormattedCurrency amount={t.amount || 0} currency={t.currency} />
        </Cell>
        <Cell alignItems="center" span={4} data-cy="cell">
          <FormattedMessage id={status[t.status] || status.P} />
        </Cell>
      </TableRow>
    ))}
  </Table>
);

VoucherTransactionsTable.propTypes = {
  transactions: voucherTransactionsShape
};

export default VoucherTransactionsTable;
